export default __webpack_public_path__ + "static/media/icon_popup_registro_add.ce071591.svg";